module.exports = __webpack_public_path__ + "static/img/backgg.dd3c6885.png";